import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomManipulationService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  replaceDivWithP(html: string): string {
    // Create a temporary DOM element to manipulate the HTML
    const tempElement = this.renderer.createElement('div');
    tempElement.innerHTML = html;
    html = this.removeMetaTags(tempElement.innerHTML);

    // Extract and return the text content
    return html.replace(/<div([^>]*)>/gi, '<p$1>')
               .replace(/<\/div>/gi, '</p>');
  }

  replacePWithDiv(html: string): string {
    const tempElement = this.renderer.createElement('div');
    tempElement.innerHTML = html;
    html = this.removeMetaTags(tempElement.innerHTML);
    html = html.replace(/<p([^>]*)>\s*<\/p>/gi, '<div$1><br></div>');
    return html.replace(/<p([^>]*)>/gi, '<div$1>')
               .replace(/<\/p>/gi, '</div>');
  }

  removeMetaTags(html: string): string {
    // Remove all <meta> tags and their contents
    return html.replace(/<meta[^>]*>/gi, '');
  }
}
